import React, { useState } from "react";
import NotificationBell from "../../assets/images/svg/notificationBell.svg";
import bellForModal from "../../assets/images/svg/bellForModal.svg";
import Modal from "../Modal";
import SettingPermitModal from "../SettingPermitModal/SettingPermitModal";
import ToggleButton from "../ToggleButton/ToggleButton";
import { Observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";

const SettingNotification = () => {
  const [openModal, setOpenModal] = useState(false);

  const handleChangeNotification = () => {
    if (!SettingsStore.isNotification) {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateNotification();
    } else {
      setOpenModal(true);
    }
  };

  const toggle = () => {
    setOpenModal(false);
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    SettingsStore.callUpdateNotification();
  };

  return (
    <Observer>
      {() => (
        <>
          <div className="setting_noti_container">
            <div className="setting_title">
              <img src={NotificationBell} alt="bell" />
              <h2>Notification Settings</h2>
            </div>
            <h2 className="noti_msg">
              Enable notification on your desktop to stay updated.
            </h2>
            <div className="toggler">
              <h2>Show Notifications</h2>
              <ToggleButton
                isToggleDisable={!SettingsStore.isNotification}
                handleToggle={handleChangeNotification}
              />
            </div>
          </div>

          <Modal
            onClose={() => setOpenModal(false)}
            open={openModal}
            width="438px"
            minWidth="438px"
            modalContainerClass="disable_device_modal_container"
          >
            <SettingPermitModal
              isToggleDisable={!SettingsStore.isNotification}
              type={"notification"}
              onClose={() => setOpenModal(false)}
              userType={"Notifications"}
              image={bellForModal}
              toggle={toggle}
            />
          </Modal>
        </>
      )}
    </Observer>
  );
};

export default SettingNotification;
